import { prefixClass } from 'lib/utils';
import { SearchRow } from './components/SearchRow';
import { FiltersRow, FiltersRowProps } from './components/FiltersRow';
import './BrowserToolbar.scss';

export interface BrowserToolbarProps extends Omit<FiltersRowProps, never> {
  // Search
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
  // Create actions
  onCreateTodo?: () => void;
  onCreateEmail?: () => void;
  onCreateGroup?: () => void;
}

/**
 * BrowserToolbar - Container component for the browser panel toolbar.
 * Orchestrates SearchRow and FiltersRow.
 */
export const BrowserToolbar = ({
  searchQuery,
  onSearchChange,
  onCreateTodo,
  onCreateEmail,
  onCreateGroup,
  // FiltersRow props
  sortAscending,
  onSortToggle,
  dateField,
  onDateFieldChange,
  mentionFilterActive,
  attachmentFilterActive,
  assignedFilterActive,
  workStateFilter,
  dueDateFilter,
  dateRangeFilter,
  requestTypeFilter,
  onMentionFilterToggle,
  onAttachmentFilterToggle,
  onAssignedFilterToggle,
  onWorkStateFilterChange,
  onDueDateFilterChange,
  onDateRangeFilterChange,
  onRequestTypeFilterChange,
  mentionCount,
  attachmentCount,
  assignedCount,
  workStateCounts,
  requestTypeCounts,
  assigneeFilter,
  onAssigneeFilterChange,
  assigneeOptions,
  activeView,
  groupCount,
  groupFilterActive,
  onGroupFilterToggle,
}: BrowserToolbarProps) => {
  const prefix = prefixClass('ksq2-browser-toolbar');

  return (
    <div className={prefix()}>
      <SearchRow
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        onCreateTodo={onCreateTodo}
        onCreateEmail={onCreateEmail}
        onCreateGroup={onCreateGroup}
        activeView={activeView}
      />
      <FiltersRow
        sortAscending={sortAscending}
        onSortToggle={onSortToggle}
        dateField={dateField}
        onDateFieldChange={onDateFieldChange}
        mentionFilterActive={mentionFilterActive}
        attachmentFilterActive={attachmentFilterActive}
        assignedFilterActive={assignedFilterActive}
        workStateFilter={workStateFilter}
        dueDateFilter={dueDateFilter}
        dateRangeFilter={dateRangeFilter}
        requestTypeFilter={requestTypeFilter}
        onMentionFilterToggle={onMentionFilterToggle}
        onAttachmentFilterToggle={onAttachmentFilterToggle}
        onAssignedFilterToggle={onAssignedFilterToggle}
        onWorkStateFilterChange={onWorkStateFilterChange}
        onDueDateFilterChange={onDueDateFilterChange}
        onDateRangeFilterChange={onDateRangeFilterChange}
        onRequestTypeFilterChange={onRequestTypeFilterChange}
        mentionCount={mentionCount}
        attachmentCount={attachmentCount}
        assignedCount={assignedCount}
        workStateCounts={workStateCounts}
        requestTypeCounts={requestTypeCounts}
        assigneeFilter={assigneeFilter}
        onAssigneeFilterChange={onAssigneeFilterChange}
        assigneeOptions={assigneeOptions}
        activeView={activeView}
        groupCount={groupCount}
        groupFilterActive={groupFilterActive}
        onGroupFilterToggle={onGroupFilterToggle}
      />
    </div>
  );
};
